// extracted by mini-css-extract-plugin
module.exports = {"title":"TitleBlock-module__title___2oxIZ","necessary":"TitleBlock-module__necessary___33qxg","description":"TitleBlock-module__description___16dsX"};